import {
  BaseModal,
  Button,
  Input,
  Multiselect,
  ToastMessage
} from '@cokitchen/cokitchen-components';
import useTeamListContext from 'contexts/team-list.context';
import { TeamType } from 'models/team-list.model';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { apiService } from 'utils/api';
import { KITCHEN_STAFF_ROLES } from 'utils/enum';

const AddMember = ({ onClose }: { onClose: (success?: boolean) => void }) => {
  const [formData, setFormData] = useState({} as TeamType);
  const [loading, setLoading] = useState(false);
  const { departments } = useTeamListContext();

  const handleChange = (value: string, fieldType: keyof TeamType) => {
    setFormData({
      ...formData,
      [fieldType]: value
    });
  };
  const isFormDataInValid = (formData: TeamType): boolean => {
    return (
      !formData.department_id ||
      !formData.first_name ||
      !formData.last_name ||
      !formData.role ||
      !formData.staff_number
    );
  };

  const addMember = async () => {
    setLoading(true);
    try {
      const res = await apiService.post('kitchen/staff', {
        data: formData,
        baseUrl: process.env.REACT_APP_KITCHEN_API_URL
      });
      if (res.status === 201) {
        onClose(true);
        toast(<ToastMessage type='success' message={res.data.message} />);
      }
    } catch (error: any) {
      onClose();
      toast(<ToastMessage type='error' message={error.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };

  const kitchenStaffRolesArray = Object.values(KITCHEN_STAFF_ROLES).map((role) => ({
    text: role,
    value: role
  }));

  return (
    <BaseModal position='right' title='Add Member' isOpen onRequestClose={() => onClose()}>
      <Input
        name='staff_number'
        label='Staff Number'
        placeholder='SN-001'
        small
        onChange={(e) => handleChange(e.target.value, 'staff_number')}
        value={formData.staff_number}
      />
      <div className='grid grid-cols-2 gap-2 my-6'>
        <Input
          name='first_name'
          label='First Name'
          placeholder='Jeffery'
          small
          onChange={(e) => handleChange(e.target.value, 'first_name')}
          value={formData.first_name}
        />
        <Input
          name='last_name'
          label='Last Name'
          placeholder='Williams'
          small
          onChange={(e) => handleChange(e.target.value, 'last_name')}
          value={formData.last_name}
        />
      </div>
      <div className='mb-6'>
        <Input
          name='phone_number'
          label='Phone Number'
          placeholder='07030000000'
          small
          type='tel'
          onChange={(e) => handleChange(e.target.value, 'phone_number')}
          value={formData.phone_number}
        />
      </div>
      <div className='mb-6'>
        <Input
          name='email'
          label='Email'
          placeholder='example@gmail.com'
          small
          type='email'
          onChange={(e) => handleChange(e.target.value, 'email')}
          value={formData.email}
        />
      </div>
      <div className='mb-6'>
        <label className='font-medium'>Department</label>
        <Multiselect
          placeholder='Select Department'
          isSingle
          values={formData.department_id ? [formData.department_id] : []}
          options={departments}
          onChange={(e) => {
            handleChange(e[0], 'department_id');
          }}
        />
      </div>
      <div className='mb-6'>
        <label className='font-medium'>Role</label>
        <Multiselect
          placeholder='Select Role'
          isSingle
          values={formData.role ? [formData.role] : []}
          options={kitchenStaffRolesArray}
          onChange={(e) => {
            handleChange(e[0], 'role');
          }}
        />
      </div>
      <div className='mt-16'>
        <Button
          color='primary'
          variant='block'
          className='ms-auto max-w-[218px] h-[49px]'
          disabled={isFormDataInValid(formData)}
          onClick={addMember}
          loading={loading}>
          Confirm
        </Button>
      </div>
    </BaseModal>
  );
};

export default AddMember;
